@if (machine && machineForm){
<div class="form-container" [class.loading-overlay]="isLoading">
  <form class="detail-form" [formGroup]="machineForm">
    <div class="fixed-buttons">
      <div class="button-container">
        <button class="action-button" mat-raised-button matTooltip="Gå tillbaka till föregående sida"
          (click)="goBack()"><mat-icon fontIcon="arrow_back" class="button-icon-no-text"></mat-icon></button>

        @if(authService.isPolicyPT()) {
        <button class=" action-button" mat-raised-button matTooltip="Kopiera"
          [disabled]="this.machine.id === 0 || this.machineHasOtherChanges || this.machineForm.dirty"
          (click)="duplicateMachine()">Kopiera</button>

        <button class="action-button" mat-raised-button matTooltip="Ladda om maskin"
          [disabled]="this.machine.id === 0 || (!this.machineHasOtherChanges && (!this.machineForm.dirty || !this.machineForm.valid))"
          (click)="reloadMachineDetailsView()">
          <mat-icon fontIcon="refresh" class="button-icon-no-text"></mat-icon>
        </button>

        <button class="action-button main-action-button" mat-raised-button matTooltip="Spara"
          [disabled]="saveDisabled || isLoading" (click)="saveChanges()">
          @if (isLoading) {
          <mat-spinner diameter="20"></mat-spinner>
          } @else {
          Spara
          }
        </button>
        }
      </div>
    </div>

    <div class="info-container-single-row">
      @if(machineIsNew) {
      <div class="new-machine-message">
        <h4 class="form-header">Ny maskin
          @if(duplicatedFrom) {<strong>{{ machine.baseInfo.machineId }}</strong> <span> är skapad som kopia av {{
            duplicatedFrom }}</span>}</h4>
      </div>
      }

      <div class="header-with-badge">
        <h4 class="form-header">Grunduppgifter</h4>
        @if (isDemoMachine) {
        <span class="demo-badge">
          <mat-icon fontIcon="info"></mat-icon>
          DEMOMASKIN
        </span>
        }
      </div>

      <div class="base-info-forms" formGroupName="baseInfo">
        <mat-form-field floatLabel="always" disabled class="fm-always-readonly-mandatory-mat-form-field">
          <mat-label>Maskinnummer</mat-label>
          <input matInput type="string" formControlName="machineId" readonly />
        </mat-form-field>

        <mat-form-field floatLabel="always" disabled class="fm-always-readonly-mandatory-mat-form-field">
          <mat-label>Maskintyp</mat-label>
          <input matInput type="string" [value]="this.machineForm.get('baseInfo.machineType')?.value == machineType.Forwarder ?
          machineTypeLabels[machineType.Forwarder] : machineTypeLabels[machineType.Harvester]" readonly />
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Tillverkare</mat-label>
          <mat-select formControlName="machineManufacturerId">
            @if (definitionService.isLoading())
            {
            <mat-option>Loading...</mat-option>
            }
            @for (manufacturer of definitionService.machineManufacturers(); track manufacturer.id) {
            <mat-option [value]="manufacturer.id">
              {{ manufacturer.name }}
            </mat-option>
            }
          </mat-select>

          @if (definitionService.isLoading())
          {
          <mat-progress-spinner matSuffix diameter="16" mode="indeterminate">
          </mat-progress-spinner>
          }
          @if (definitionService.error())
          {
          <mat-error>
            {{ definitionService.error() }}
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Modell</mat-label>

          <mat-select formControlName="machineManufacturerModelId">
            @if (definitionService.isLoading())
            {
            <mat-option>Loading...</mat-option>
            }
            @for (manufacturerModels of definitionService.machineManufacturerModels(); track manufacturerModels.id) {
            <mat-option [value]="manufacturerModels.id">
              {{ manufacturerModels.name }}
            </mat-option>
            }
          </mat-select>

          @if (definitionService.isLoading())
          {
          <mat-progress-spinner matSuffix diameter="16" mode="indeterminate">
          </mat-progress-spinner>
          }

          @if (definitionService.error())
          {
          <mat-error>
            {{ definitionService.error() }}
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Registreringsnr</mat-label>
          <input matInput type="string" formControlName="registrationNumber" />
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Tillverkningsnr</mat-label>
          <input matInput type="string" formControlName="manufacturingNumber" />
        </mat-form-field>


        <mat-form-field floatLabel="always" appearance="fill" class="fm-readonly-mat-form-field">
          <mat-label>Storlek</mat-label>
          <input matInput type="string" formControlName="machineSizeText" readonly />
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Årsmodell</mat-label>
          <input matInput type="number" formControlName="machineModelYear" min="1970" step="1" />
        </mat-form-field>

        @if (machineForm.value.baseInfo?.ownerType == 2) {
        <mat-form-field appearance="outline" floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" style="position: relative;">
          <mat-label>Ansvarig entreprenör</mat-label>
          <mat-select formControlName="machineOwnerId" (selectionChange)="onOwnerChanged($event.value)">
            @if(showStoredOwnerName) {
            <mat-option disabled selected [value]="machine.baseInfo.machineOwnerId">*?
              {{machine.baseInfo.machineOwnerText}}</mat-option>
            }
            @for(contractor of allContractors; track contractor.id)
            {
            <mat-option [value]="contractor.id">{{ contractor.companyName }}</mat-option>
            }
          </mat-select>
          @if (machineForm.get('baseInfo.machineOwnerId')?.value) {
          <fa-icon class="clickable-contractor-icon" [icon]="iconService.getIcon('link', true)"
            (click)="navigateToContractor($event, machineForm.get('baseInfo.machineOwnerId')?.value ?? null)">
            ></fa-icon>
          }
          @if(showStoredOwnerName) {
          <mat-hint [ngClass]="{ 'info-text-readonly' : isReadonly, 'info-text' : !isReadonly }">
            *? Entreprenör saknar avtal.
          </mat-hint>
          }
        </mat-form-field>
        }

        <mat-form-field floatLabel="always" [appearance]="isReadonly || isDemoMachine ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : (isReadonly || isDemoMachine)}">
          <mat-label>Ägartyp</mat-label>
          @if(isDemoMachine) {
          <input matInput type="text" [value]="ownerTypeText" readonly />
          } @else {
          <mat-select formControlName="ownerType" [disabled]="isReadonly"
            (selectionChange)="onOwnerTypeChanged($event.value)">
            @for(ownerType of ownerTypeEnum; track ownerType)
            {
            <mat-option [value]="ownerType">{{ ownerTypeLabels[ownerType] }}</mat-option>
            }
          </mat-select>
          }
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            @for(status of machineStatusEnum; track status)
            {
            <mat-option [value]="status">{{ machineStatusLabels[status] }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (machine.baseInfo.machineType == 2) {
        <mat-checkbox formControlName="isSchoolForwarder"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Skolskotare</mat-checkbox>
        }
        @if (machine.baseInfo.machineType == 2) {
        <mat-checkbox formControlName="isGrotForwarder"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Grotskotare</mat-checkbox>
        }

        @if (authService.isPolicyDeveloper()) {
        <span [matTooltip]="hasTeamConnections ? 'Ta bort maskinlag innan maskinen kan markeras som demomaskin.' : ''">
          <mat-checkbox formControlName="isDemoMachine" [disabled]="hasTeamConnections">Demomaskin</mat-checkbox>
        </span>
        }

        <mat-form-field floatLabel="always" appearance="fill" class="fm-readonly-mat-form-field">
          <mat-label>Skapad</mat-label>
          <input matInput type="string" formControlName="created" readonly />
        </mat-form-field>

        <mat-form-field floatLabel="always" appearance="outline"
          class="fm-readonly-mat-form-field base-info-forms-teams"
          [class.base-info-forms-teams-editable]="authService.isPolicyPT() && !isDemoMachine">
          <mat-label>Maskinlag</mat-label>
          <div class="teams-display" (click)="authService.isPolicyPT() && !isDemoMachine ? addTeam() : null">
            @if(activeTeams.length === 0) {
            <span class="teams-empty" (click)="authService.isPolicyPT() && !isDemoMachine ? addTeam() : null">Inga lag
              @if(this.authService.isPolicyPT() && !isDemoMachine)
              { <span>- klicka
                för att koppla maskinlag</span> }</span>
            } @else {
            @for(team of activeTeams; track team.id) {
            <div class="regular-link team-details-link" (click)="navigateToTeam(team)" [matTooltip]="team.name"
              matTooltipShowDelay="300">
              <span>{{team.teamId}} </span> <span>{{team.name}}</span>
            </div>
            }
            }
          </div>
          <textarea matInput formControlName="teams" style="display: none;" readonly></textarea>

          @if(this.authService.isPolicyPT() && !isDemoMachine) {
          <mat-icon matSuffix class="add-team-icon" (click)="addTeam()" matTooltip="Koppla maskinlag"
            aria-label="Lägg till lag" fontIcon="add"></mat-icon>
          }
        </mat-form-field>

        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" class="base-info-forms-notes">
          <mat-label>Anteckningar</mat-label>
          <textarea matInput formControlName="notes" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1" cdkAutosizeMaxRows="4"></textarea>
        </mat-form-field>
        <app-entity-relation-change-transaction-details
          [entityRelationChangeTransactionDetails]="machine.baseInfo.entityRelationChangeTransactionDetails"
          [lastModified]="machine.baseInfo.lastModified" [isReadonly]="isReadonly">
        </app-entity-relation-change-transaction-details>
      </div>
    </div>
    <div class="production-biometria-container">
      <div class="production-info-container">
        <h4 class="form-header">Produktionsuppgifter</h4>
        <div class="secondary-info-forms" formGroupName="productionInfo">

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Grundprest. (m3fub/h)</mat-label>
            <input matInput type="number" formControlName="productionBasePerformanceM3FubPerHour" min="0" step="1" />
          </mat-form-field>

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Bränsleförbrukning</mat-label>
            <input matInput type="number" formControlName="fuelConsumptionInLitersPerG5h" min="0" step="0.1" />
          </mat-form-field>

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Oljeförbrukning</mat-label>
            <input matInput type="number" formControlName="oilConsumptionInLitersPerG5h" min="0" step="0.1" />
          </mat-form-field>

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Antal hjul</mat-label>
            <input matInput type="number" formControlName="numberOfWheels" min="0" step="1" />
          </mat-form-field>

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Däckdimension</mat-label>
            <input matInput type="string" formControlName="tireDimension" />
          </mat-form-field>

          @if(machine.baseInfo.machineType == machineType.Forwarder) {
          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Lastkapacitet</mat-label>
            <input matInput type="number" formControlName="loadingCapacity" min="0" step="1" />
          </mat-form-field>
          }

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Kranlängd</mat-label>
            <input matInput type="number" formControlName="craneLength" min="0" step="1" />
          </mat-form-field>

          @if (this.machineForm.get('baseInfo.machineType')?.value === machineType.Harvester)
          {
          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Aggregat</mat-label>
            <mat-select formControlName="harvesterHeadId">
              @if (definitionService.isLoading())
              {
              <mat-option>Loading...</mat-option>
              }
              @for (harvesterHead of definitionService.harvesterHeads(); track harvesterHead.id) {
              <mat-option [value]="harvesterHead.id">
                {{ harvesterHead.name }}
              </mat-option>
              }
            </mat-select>

            @if (definitionService.isLoading())
            {
            <mat-progress-spinner matSuffix diameter="16" mode="indeterminate">
            </mat-progress-spinner>
            }
            @if (definitionService.error())
            {
            <mat-error>
              {{ definitionService.error() }}
            </mat-error>
            }
          </mat-form-field>
          }

        </div>
      </div>
      <div class="biometria-info-container">
        <h4 class="form-header">Biometriauppgifter</h4>
        <div class="secondary-info-forms" formGroupName="biometriaInfo">

          <mat-form-field floatLabel="always" [appearance]="(isReadonly || isDemoMachine) ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : (isReadonly || isDemoMachine)}">
            <mat-label>Avverkningsföretag-Id</mat-label>
            <input matInput type="text" formControlName="biometriaCompanyId" [readonly]="isDemoMachine" />
            @if (companyIdField?.invalid && companyIdField?.touched) {
            <mat-icon matSuffix class="error-icon" [matTooltip]="getErrorMessage('biometriaInfo.biometriaCompanyId')"
              matTooltipPosition="above">
              error
            </mat-icon>
            }
            @else {
            <app-copy-to-clipboard-button matSuffix
              [valueToCopy]="companyIdField.value ?? null"></app-copy-to-clipboard-button>
            }

          </mat-form-field>

          <mat-form-field floatLabel="always"
            [appearance]="(isReadonly || (isDemoMachine && !authService.isPolicyDeveloper())) ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly || (isDemoMachine && !authService.isPolicyDeveloper())}">
            <mat-label>SDCID</mat-label>
            <input matInput type="string" formControlName="biometriaGpxId" />
            @if (machineForm.get('biometriaInfo.biometriaGpxId')?.invalid &&
            machineForm.get('biometriaInfo.biometriaGpxId')?.touched) {
            <mat-icon matSuffix class="error-icon" [matTooltip]="getErrorMessage('biometriaInfo.biometriaGpxId')"
              matTooltipPosition="above">
              error
            </mat-icon>
            }
            @else {
            <app-copy-to-clipboard-button matSuffix
              [valueToCopy]="machineForm.get('biometriaInfo.biometriaGpxId')?.value ?? null"></app-copy-to-clipboard-button>
            }

          </mat-form-field>

          <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
            [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
            <mat-label>Lösenord</mat-label>
            <input matInput type="string" formControlName="biometriaPassword" />
            <app-copy-to-clipboard-button matSuffix
              [valueToCopy]="machineForm.get('biometriaInfo.biometriaPassword')?.value ?? null"></app-copy-to-clipboard-button>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="info-container-single-row">
      <h4 class="form-header">Utrustning</h4>

      <div class="secondary-info-forms" formGroupName="equipmentInfo">
        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>Maskindator</mat-label>
          <mat-select formControlName="machineComputerId">
            @if (definitionService.isLoading()) {
            <mat-option>Loading...</mat-option>
            }
            @for (machineComputer of machineComputersSorted(); track machineComputer.id) {
            <mat-option [value]="machineComputer.id">
              {{ machineComputer.name }}
            </mat-option>
            }
          </mat-select>

          @if (definitionService.isLoading())
          {
          <mat-progress-spinner matSuffix diameter="16" mode="indeterminate">
          </mat-progress-spinner>
          }
          @if (definitionService.error())
          {
          <mat-error>
            {{ definitionService.error() }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field floatLabel="always" [appearance]="isReadonly ? 'fill': 'outline'"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
          <mat-label>StanForD2010 version</mat-label>
          <mat-select formControlName="stanford2010Version">
            @for(stanford2010Version of stanford2010VersionEnumIterable; track stanford2010Version)
            {
            <mat-option [value]="stanford2010Version"
              [disabled]="stanford2010Version === stanford2010VersionEnum.TwoPointOne">
              {{ stanford2010VersionLabels[stanford2010Version] }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field floatLabel="always" appearance="fill" class="fm-readonly-mat-form-field">
          <mat-label>Stina-version</mat-label>
          <input matInput type="string" formControlName="stinaVersion" readonly />
        </mat-form-field>
        <mat-form-field floatLabel="always" appearance="fill" class="fm-readonly-mat-form-field">
          <mat-label>Masen-version</mat-label>
          <input matInput type="string" formControlName="masenVersion" readonly />
        </mat-form-field>
        <mat-form-field floatLabel="always" appearance="fill" class="fm-readonly-mat-form-field">
          <mat-label>Windows-version</mat-label>
          <input matInput type="string" formControlName="windowsVersion" readonly />
        </mat-form-field>

        <mat-checkbox formControlName="hasHighPrecisionCraneTipCoordinate"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Kranspetskoordinat, högprecision</mat-checkbox>
        <mat-checkbox formControlName="hasRtk"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">RTK</mat-checkbox>
        <mat-checkbox formControlName="fileSendingActive"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Filskick aktivt</mat-checkbox>
        <mat-checkbox formControlName="sendPinFilesForPulp"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Skicka massafiler</mat-checkbox>
        <mat-checkbox formControlName="sendAptFilesViaMasen"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Skicka apteringsfiler via Masen</mat-checkbox>
        <mat-checkbox formControlName="useProductionFilesFromMasen"
          [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">Använd produktionsfiler från Masen</mat-checkbox>
      </div>
    </div>

    <div class="info-container-single-row">
      <h4 class="form-header">Arbetstimmar</h4>

      <div class="secondary-info-comp">
        <app-machine-work-hours [machineWorkHours]="machine.machineWorkHours"
          (machineChanged)="onMachineChanged($event)"
          (machineWorkHoursValidates)="onMachineWorkHoursValidatesChanged($event)"> </app-machine-work-hours>
      </div>
    </div>

    <div class="info-container-single-row">
      <div class="performance-header">
        <h4 class="form-header">Prestationer | Område: {{ machine.defaultMachinePerformanceArea ?
          getDefaultMachinePerformanceAreaDisplayName(machine.defaultMachinePerformanceArea) : '-' }}</h4>
        @if(authService.isPolicyPT()) {
        <button mat-raised-button class="set-default-performance-area-button" (click)="setDefaultPerformance()">Välj
          område</button>
        }
      </div>

      <div class="secondary-info-comp">

        <app-machine-performance [regenerationPerformance]="machine.regenerationPerformance"
          [thinningPerformance]="machine.thinningPerformance" [machineType]="machine.baseInfo.machineType"
          (machineChanged)="onMachineChanged($event)">
        </app-machine-performance>

      </div>
    </div>
  </form>
</div>
}